import clsx from 'clsx'
import s from './style.module.scss'

interface Props {
  className?: string
  solid?: boolean
}

const Divider = ({className, solid}: Props) => {
  return <div className={clsx(s.divider, {[s.solid]: solid}, className)} />
}

export default Divider
